import { MediaUploadResponse } from "../types/media.types";

export const formatMediaResponse = (
  response: MediaUploadResponse
): MediaUploadResponse & {
  displayUrl: string;
  shortFileName: string;
  formattedSize: string;
} => {
  const shortFileName =
    response.fileName.length > 20
      ? `${response.fileName.substring(0, 17)}...${response.fileName.split(".").pop()}`
      : response.fileName;

  const formattedSize =
    response.fileSize < 1024 * 1024
      ? `${(response.fileSize / 1024).toFixed(2)} KB`
      : `${(response.fileSize / (1024 * 1024)).toFixed(2)} MB`;

  return {
    ...response,
    displayUrl: response.url.split("?")[0], // Remove query parameters
    shortFileName,
    formattedSize,
  };
};

export const formatMediaRequest = (file: File): FormData => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("originalFileName", file.name);
  formData.append("fileType", file.type);
  formData.append("fileSize", file.size.toString());
  return formData;
};

export const formatBatchMediaRequest = (files: File[]): FormData => {
  const formData = new FormData();
  files.forEach((file, index) => {
    formData.append(`files[${index}]`, file);
    formData.append(`originalFileNames[${index}]`, file.name);
    formData.append(`fileTypes[${index}]`, file.type);
    formData.append(`fileSizes[${index}]`, file.size.toString());
  });
  return formData;
};
